export class ClickAndCollectConfiguration {
  enableClickAndCollect: boolean | null;
  enableDelivery: boolean | null;

  constructor(enableClickAndCollect: boolean | null, enableDelivery: boolean | null) {
    this.enableClickAndCollect = enableClickAndCollect;
    this.enableDelivery = enableDelivery;
  }
}
